import React from "react";
import { useParams } from "react-router-dom";
import DynamicTabs from "../common/DynamicTabs";
import { StoreTabsConfig } from "./constants/storeTabsConfig";
import NoStoreDetailFound from "./NoStoreDetailFound";

const StoreDetailPage: React.FC = () => {
  const { storeId } = useParams<{ storeId: string }>();

  if (!storeId) return <NoStoreDetailFound />;

  return <DynamicTabs tabsConfig={StoreTabsConfig(storeId)} defaultTab={0} />;
};

export default StoreDetailPage;
